import React, { Suspense, useEffect } from "react";
import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Loader from "./components/Commons/Loader/Loader";
import PaymentGatewayRspV2 from "./components/Retailer/WalletLoad/WalletLoadResp/PaymentGatewayRspV2";
import PayrentRespV2 from "./components/Retailer/Payrent/PayrentResp/PayrentRespV2";
import swal from "sweetalert";
import { apiFormatGet } from "./Api/ApiFormat";
import FingerprintJS from "fingerprintjs2";
const Layout = React.lazy(() => import("./components/layout/Layout"));
const RetailerDashboard = React.lazy(() =>
  import("./pages/retailerDashboard/Dashboard")
);

const SuperDistributorLayout = React.lazy(() =>
  import("./components/SuperDistributor/layout/Layout")
);

const Login = React.lazy(() => import("./components/Login/Login"));
const AEPSMain = React.lazy(() =>
  import("./components/Retailer/AEPS/AEPSMain")
);
const NotFoundPage = React.lazy(() =>
  import("./components/NotFoundPage/NotFoundPage")
);
const DmtMain = React.lazy(() =>
  import("./components/Retailer/Dmt/DmtMain/DmtMain")
);
const LedgerReports = React.lazy(() =>
  import("./components/Retailer/Reports/LedgerReports/LedgerReports")
);
const ExpressDmtMain = React.lazy(() =>
  import("./components/Retailer/Express dmt/Dmt/DmtMain/DmtMain")
);
const ExpressDmtV2Main = React.lazy(() =>
  import("./components/Retailer/Express dmt/DmtV2/DmtMain/DmtMain")
);
const DMTReports = React.lazy(() =>
  import("./components/Retailer/Reports/DMTReports/DMTReports")
);

const MatmTranssactionReports = React.lazy(() =>
  import(
    "./components/Retailer/Reports/MatmTranssactionReports/MatmTranssactionReports"
  )
);

const ExpressDMTReports = React.lazy(() =>
  import("./components/Retailer/Reports/ExpressDmtReports/ExpressDMTReports")
);

const ReceiveTopUpReport = React.lazy(() =>
  import("./components/Retailer/Reports/ReceiveTopUpReport/ReceiveTopUpReport")
);

const PayoutReports = React.lazy(() =>
  import("./components/Retailer/Reports/PayoutReports/PayoutReports")
);

const WalletLoadReports = React.lazy(() =>
  import("./components/Retailer/Reports/WalletLoadReports/WalletLoadReports")
);
const WalletLoadReportsV2 = React.lazy(() =>
  import("./components/Retailer/Reports/WalletLoadReports/WalletLoadReportsV2")
);

const WalletLoadReportPGT2 = React.lazy(() =>
  import("./components/Retailer/Reports/WalletLoadReports/WalletLoadReportPGT2")
);
const WalletLoadReportPGT3 = React.lazy(() =>
  import("./components/Retailer/Reports/WalletLoadReports/WalletLoadReportPGT3")
);

const WalletLoadReportPGT4 = React.lazy(() =>
  import("./components/Retailer/Reports/WalletLoadReports/WalletLoadReportPGT4")
);
const WalletLoadReportPGT5 = React.lazy(() =>
  import("./components/Retailer/Reports/WalletLoadReports/WalletLoadReportPGT5")
);
const AepsTransactReports = React.lazy(() =>
  import(
    "./components/Retailer/Reports/AepsTransactReports/AepsTransactReports"
  )
);

const AepsPayoutReports = React.lazy(() =>
  import("./components/Retailer/Reports/AepsPayoutReports/AepsPayoutReports")
);

const AepsPayoutNewReport = React.lazy(() =>
  import(
    "./components/Retailer/Reports/AepsPayoutNewReport/AepsPayoutNewReport"
  )
);

const RechargeReports = React.lazy(() =>
  import("./components/Retailer/Reports/RechargeReports/RechargeReports")
);

const AepsLedgerReports = React.lazy(() =>
  import("./components/Retailer/Reports/AepsLedgerReports/AepsLedgerReports")
);

const ScanAndPayReports = React.lazy(() =>
  import("./components/Retailer/Reports/ScanAndPayReports/ScanAndPayReports")
);

const PayRentReports = React.lazy(() =>
  import("./components/Retailer/Reports/PayRentReports/PayRentReports")
);

const DMTV2Reports = React.lazy(() =>
  import("./components/Retailer/Reports/DMTV2Reports/DMTV2Reports")
);

const RefundWallet = React.lazy(() =>
  import("./components/Retailer/RefundWallet/RefundWallet")
);

// const AepsToBank = React.lazy(() =>
//   import("./components/Retailer/AEPS/AepsPayout/AepsToBank/AepsToBank")
// );

const AepsToBankV2 = React.lazy(() =>
  import("./components/Retailer/AEPS/AepsPayout/AepsToBankV2/AepsToBankV2")
);

const PayoutToBank = React.lazy(() =>
  import("./components/Retailer/Payout/Payout")
);

const AepsToWallet = React.lazy(() =>
  import("./components/Retailer/AEPS/AepsPayout/AepsToWallet/AepsToWallet")
);
const MobileRecharge = React.lazy(() =>
  import("./components/Retailer/Recharge/MobileRecharge/MobileRecharge")
);
const MobilePostpaidResp = React.lazy(() =>
  import("./components/Retailer/Recharge/MobileRecharge/MobilePostpaidResp")
);
const DTHRecharge = React.lazy(() =>
  import("./components/Retailer/Recharge/DTHRecharge/DTHRecharge")
);

const PayrentMain = React.lazy(() =>
  import("./components/Retailer/Payrent/PayrentMain")
);
const PayrentResp = React.lazy(() =>
  import("./components/Retailer/Payrent/PayrentResp/PayrentResp")
);
const PayrentRazorpayResp = React.lazy(() =>
  import("./components/Retailer/Payrent/PayrentResp/PayrentRazorpayResp")
);

const CMSResp = React.lazy(() =>
  import("./components/Retailer/CMS/CMSResp/CMSResp")
);

const MyDetails = React.lazy(() =>
  import("./components/Retailer/MyDetails/MyDetails")
);
const MaintenancePage = React.lazy(() =>
  import("./components/MaintenancePage/MaintenancePage")
);
const Complaints = React.lazy(() =>
  import("./components/Retailer/Complaints/Complaints")
);
const WalletToWallet = React.lazy(() =>
  import("./components/Retailer/WalletToWallet/WalletToWallet")
);
const Support = React.lazy(() => import("./components/Support/Support"));
const YPayAcc = React.lazy(() =>
  import("./components/Retailer/Ypay/YpayAcc/YpayAcc")
);
const CardSelection = React.lazy(() =>
  import("./components/Retailer/Ypay/CardSelection/CardSelection")
);
const KYC = React.lazy(() => import("./components/Retailer/Ypay/KYC/KYC"));
const Registration = React.lazy(() =>
  import("./components/Retailer/Ypay/Registration/Registration")
);
const DmtMainV2 = React.lazy(() =>
  import("./components/Retailer/DmtV2/DmtMain/DmtMain")
);
const AssignCard = React.lazy(() =>
  import("./components/Retailer/Ypay/AssignCard/AssignCard")
);
const YpayServicesPage = React.lazy(() =>
  import("./components/Retailer/Ypay/YpayServicesPage/YpayServicesPage")
);
const TransactionHistory = React.lazy(() =>
  import(
    "./components/Retailer/Ypay/YpayServicesPage/TransactionHistory/TransactionHistory"
  )
);
const AccountOpenReports = React.lazy(() =>
  import("./components/Retailer/Reports/AccountOpenReports/AccountOpenReports")
);
const PrepaidCards = React.lazy(() =>
  import(
    "./components/Retailer/Ypay/YpayServicesPage/PrepaidCards/PrepaidCards"
  )
);
const LoadAcc = React.lazy(() =>
  import("./components/Retailer/Ypay/YpayServicesPage/LoadAcc/LoadAcc")
);

const WalletLoadResp = React.lazy(() =>
  import("./components/Retailer/WalletLoad/WalletLoadResp/WalletLoadResp")
);
const RazorWalletLoadResp = React.lazy(() =>
  import("./components/Retailer/WalletLoad/WalletLoadResp/RazorWalletLoadResp")
);
const WalletLoadRespV2 = React.lazy(() =>
  import("./components/Retailer/WalletLoad/WalletLoadResp/WalletLoadRespV2")
);

const RazorWalletLoadRespV2 = React.lazy(() =>
  import(
    "./components/Retailer/WalletLoad/WalletLoadResp/RazorWalletLoadRespV2"
  )
);
const RazorpayPgOneTPlusOneResp = React.lazy(() =>
  import(
    "./components/Retailer/WalletLoad/WalletLoadResp/RazorpayPgOneTPlusOneResp"
  )
);
const RazorpayPGTTPlusOneResp = React.lazy(() =>
  import(
    "./components/Retailer/WalletLoad/WalletLoadResp/RazorpayPGTTPlusOneResp"
  )
);
const RazorpayPGTTwoTPlusOneResp = React.lazy(() =>
  import(
    "./components/Retailer/WalletLoad/WalletLoadResp/RazorpayPGTTwoTPlusOneResp"
  )
);
const RazorWalletLoadPGT2Resp = React.lazy(() =>
  import(
    "./components/Retailer/WalletLoad/WalletLoadResp/RazorWalletLoadPGT2Resp"
  )
);
const PayUWalletLoadPGT3Resp = React.lazy(() =>
  import(
    "./components/Retailer/WalletLoad/WalletLoadResp/PayUWalletLoadPGT3Resp"
  )
);
const PayUWalletLoadPGT4Resp = React.lazy(() =>
  import(
    "./components/Retailer/WalletLoad/WalletLoadResp/PayUWalletLoadPGT4Resp"
  )
);
const CashFreeWalletLoadPGT5Resp = React.lazy(() =>
  import(
    "./components/Retailer/WalletLoad/WalletLoadResp/CashFreeWalletLoadPGT5Resp"
  )
);
const PayUWalletLoadPGT3TplusOneResp = React.lazy(() =>
  import(
    "./components/Retailer/WalletLoad/WalletLoadResp/PayUWalletLoadPGT3TplusOneResp"
  )
);
const PayUWalletLoadPGT4TplusOneResp = React.lazy(() =>
  import(
    "./components/Retailer/WalletLoad/WalletLoadResp/PayUWalletLoadPGT4TplusOneResp"
  )
);
const CashFreeWalletLoadPGT5TplusOneResp = React.lazy(() =>
  import(
    "./components/Retailer/WalletLoad/WalletLoadResp/CashFreeWalletLoadPGT5TplusOneResp"
  )
);
const ElectricityResp = React.lazy(() =>
  import("./components/Retailer/BBPS/ElectricityBillPayment/ElectricityResp")
);

const Bbpspgresp = React.lazy(() =>
  import("./components/Retailer/BBPS/BBPSService/BBPSResp/BbpsPGResp")
);

const AccLoadReports = React.lazy(() =>
  import("./components/Retailer/Reports/AccLoadReports/AccLoadReports")
);
const AEPSMainV2 = React.lazy(() =>
  import("./components/Retailer/AEPSV2/AepsV2MechantRegistration")
);

const MATM = React.lazy(() => import("./components/Retailer/MATM/MATM"));

//distributor

const DMATM = React.lazy(() => import("./components/Distributor/MATM/MATM"));

const LayoutDistributor = React.lazy(() =>
  import("./components/Distributor/layout/Layout")
);
const DistributorDashboard = React.lazy(() =>
  import("./pages/distributorDashboard/DistributorDashboard")
);
const SuperDistributorDashboard = React.lazy(() =>
  import("./pages/SuperDistributorDashboard/SuperDistributorDashboard")
);

const RetailersList = React.lazy(() =>
  import("./components/Distributor/RetailersList/RetailersList")
);
const RetailerProfile = React.lazy(() =>
  import("./components/Distributor/RetailerProfile/RetailerProfile")
);
const MyDetailsDistributor = React.lazy(() =>
  import("./components/Distributor/MyDetails/MyDetails")
);
const TopUpRequest = React.lazy(() =>
  import("./components/Distributor/TopUpRequest/TopUpRequest")
);
const CreateRetailerMain = React.lazy(() =>
  import("./components/Distributor/CreateRetailer/CreateRetailerMain")
);

const CreateDistributor = React.lazy(() =>
  import("./components/SuperDistributor/CreateDistributer/CreateDistributor")
);
const WalletLoadRespDistributor = React.lazy(() =>
  import("./components/Distributor/WalletLoad/WalletLoadResp/WalletLoadResp")
);
const GetTopUpRequestReports = React.lazy(() =>
  import(
    "./components/Retailer/Reports/GetTopUpRequestReports/GetTopUpRequestReports"
  )
);
const SendTopupReports = React.lazy(() =>
  import("./components/Retailer/Reports/SendTopupReports/SendTopupReports")
);
const DistributorCommission = React.lazy(() =>
  import(
    "./components/Retailer/Reports/DistributorCommission/DistributorCommission"
  )
);
const QrTransReports = React.lazy(() =>
  import("./components/Retailer/Reports/QrTransReports/QrTransReports")
);
const DistRetWalletLoadReports = React.lazy(() =>
  import(
    "./components/Retailer/Reports/DistRetWalletLoadReports/DistRetWalletLoadReports"
  )
);
const DistRetWalletLoadReportsV2 = React.lazy(() =>
  import(
    "./components/Retailer/Reports/DistRetWalletLoadReports/DistRetWalletLoadReportsV2"
  )
);
const DistRetWalletLoadPGT2 = React.lazy(() =>
  import(
    "./components/Retailer/Reports/DistRetWalletLoadReports/DistRetWalletLoadPGT2"
  )
);
const DistRetWalletLoadPGT3 = React.lazy(() =>
  import(
    "./components/Retailer/Reports/DistRetWalletLoadReports/DistRetWalletLoadPGT3"
  )
);
const DistRetWalletLoadPGT4 = React.lazy(() =>
  import(
    "./components/Retailer/Reports/DistRetWalletLoadReports/DistRetWalletLoadPGT4"
  )
);
const DistRetWalletLoadPGT5 = React.lazy(() =>
  import(
    "./components/Retailer/Reports/DistRetWalletLoadReports/DistRetWalletLoadPGT5"
  )
);
const DistRetQrReports = React.lazy(() =>
  import("./components/Retailer/Reports/DistRetQrReports/DistRetQrReports")
);
const PageprintCallback = React.lazy(() =>
  import("./components/Retailer/AEPSV2/PageprintCallback/PageprintCallback")
);
const Passbook = React.lazy(() =>
  import("./components/Retailer/Ypay/YpayServicesPage/Passbook/Passbook")
);
const CreditCardPayment = React.lazy(() =>
  import("./components/Retailer/CreditCardPayment/CreditCardPayment")
);
const Test = React.lazy(() => import("./components/Test/Test"));
const CreditCardBillPaymetnReports = React.lazy(() =>
  import(
    "./components/Retailer/Reports/CreditCardBillPaymetnReports/CreditCardBillPaymetnReports"
  )
);
const ElectricityBillPayment = React.lazy(() =>
  import("./components/Retailer/ElectricityBillPayment/ElectricityBillPayment")
);
const ElectricityBillPaymentReports = React.lazy(() =>
  import(
    "./components/Retailer/Reports/ElectricityBillPaymentReports/ElectricityBillPaymentReports"
  )
);

const CmsReports = React.lazy(() =>
  import("./components/Retailer/Reports/CmsReports/CmsReports")
);

const BBPSElectricityBillPayment = React.lazy(() =>
  import(
    "./components/Retailer/BBPS/ElectricityBillPayment/BBPSElectricityBillPayment"
  )
);
const BBPSMobilePostpaidBillPayment = React.lazy(() =>
  import(
    "./components/Retailer/BBPS/MobilePostpaidBillPayment/MobilePostpaidBillPayment"
  )
);
const BBPSCreditCardBillPayment = React.lazy(() =>
  import(
    "./components/Retailer/BBPS/CreditCardBillPayment/BBPSCreditCardBillPayment"
  )
);
const BBPSService = React.lazy(() =>
  import("./components/Retailer/BBPS/BBPSService/BBPSService")
);
// src\pages\retailerDashboard\SecurityAmountPaidResp.jsx

const SecurityAmountResponse = React.lazy(() =>
  import("./pages/retailerDashboard/SecurityAmountPaidResp")
);

const ReceiveTopUpReportSd = React.lazy(() =>
  import("./components/SuperDistributor/ReceiveTopUpReport/ReceiveTopUpReport")
);

const LedgerReportSd = React.lazy(() =>
  import("./components/SuperDistributor/LedgerReports/LedgerReports")
);

const WalletLoadReportSd = React.lazy(() =>
  import("./components/SuperDistributor/WalletLoadReports/WalletLoadReports")
);

const GetTopupRequestReportSd = React.lazy(() =>
  import(
    "./components/SuperDistributor/GetTopUpRequestReports/GetTopUpRequestReports"
  )
);

const SentTopupReportSd = React.lazy(() =>
  import("./components/SuperDistributor/SendTopupReports/SendTopupReports")
);

const DistributorListSd = React.lazy(() =>
  import("./components/SuperDistributor/RetailersList/RetailersList")
);

const DistributorProfileSd = React.lazy(() =>
  import("./components/SuperDistributor/RetailerProfile/RetailerProfile")
);

function App() {
  const navigate = useNavigate();

  const Logout = () => {
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("expires_in");
    sessionStorage.removeItem("refresh_token");
    sessionStorage.removeItem("profilePic");
    sessionStorage.removeItem("name");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("retMobile");
    sessionStorage.removeItem("timer");
    sessionStorage.removeItem("colorMode");
    sessionStorage.removeItem("themeMode");
    navigate("/login");
    sessionStorage.clear();
  };
  const generateDeviceIdentifier = async () => {
    const components = await FingerprintJS.getPromise();
    const values = components.map((component) => component.value);
    const deviceIdentifier = FingerprintJS.x64hash128(values.join(""), 31);
    return deviceIdentifier;
  };
  const reCheckLoginFunc = async () => {
    let userId = sessionStorage.getItem("userId");
    if (userId == null) return;
    let deviceId = await generateDeviceIdentifier();
    let lastLoginDeviceID = await apiFormatGet(
      "api/user/getDeviceId",
      `/${userId}`
    );
    if (lastLoginDeviceID) {
      if (lastLoginDeviceID.data?.[0]?.deviceId !== deviceId) {
        Logout();
        swal(
          "Logged Out",
          "You have been logged out as you have logged into another device.",
          "error"
        );
      }
    }
  };
  useEffect(() => {
    let time1 = setInterval(() => {
      if (navigator.onLine) {
      } else {
        Logout();
        swal("Oops", "You Are Offline!", "error");
      }
    }, 20000);
    let reCheckLogin = setInterval(() => {
      reCheckLoginFunc();
    }, 6000);

    return () => {
      clearInterval(time1);
      clearInterval(reCheckLogin);
    };
  }, [navigator.onLine]);

  var inputTypeNumbers = document.querySelectorAll("input[type=number]");
  for (var a = 0; a < inputTypeNumbers.length; a++) {
    inputTypeNumbers[a].onwheel = function (event) {
      event.target.blur();
    };
  }
  // const YpayReducer = useSelector(
  //   (state) => state.YpayReducer.getCustomerDetails
  // );
  return (
    <>
      <ToastContainer autoClose={5000} position={toast.POSITION.BOTTOM_RIGHT} />

      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/underMaintenance" element={<MaintenancePage />} />
          <Route
            path="/retailer/Dashboard"
            element={<Layout mainContent={<RetailerDashboard />} />}
          />
          <Route
            path="/retailer/securityAmountPaidResp"
            element={<Layout mainContent={<SecurityAmountResponse />} />}
          />
          <Route
            path="/retailer/devices/MATM"
            element={<Layout mainContent={<MATM />} />}
          />
          <Route
            path="/retailer/PaymentGatewayRspV2/:sid"
            element={<Layout mainContent={<PaymentGatewayRspV2 />} />}
          />
          {/* <Route
            path="/distributor/PaymentGateWayRespV2/:sid"
            element={
              <LayoutDistributor mainContent={<PaymentGatewayRspV2 />} />
            }
          />
          <Route
            path="/retailer/TutionFeesRespV2/:sid"
            element={<Layout mainContent={<PayrentRespV2 />} />}
          /> */}
          <Route
            path="/retailer/FCmsCallBack/:txnId"
            element={<Layout mainContent={<CMSResp />} />}
          />
          <Route path="/Login" element={<Login />} />
          <Route
            path="/retailer/Payout"
            element={<Layout mainContent={<PayoutToBank />} />}
          />
          <Route
            path="/retailer/DMT"
            element={<Layout mainContent={<DmtMain />} />}
          />
          <Route
            path="/retailer/DMTWithKYC"
            element={<Layout mainContent={<DmtMainV2 />} />}
          />
          <Route
            path="/retailer/ExpressDMT"
            element={<Layout mainContent={<ExpressDmtMain />} />}
          />
          <Route
            path="/retailer/ExpressDMTWithKYC"
            element={<Layout mainContent={<ExpressDmtV2Main />} />}
          />
          <Route
            path="/retailer/LedgerReport"
            element={<Layout mainContent={<LedgerReports />} />}
          />
          <Route
            path="/retailer/DMTReports"
            element={<Layout mainContent={<DMTReports />} />}
          />
          <Route
            path="/retailer/ReceiveTopUpReport"
            element={<Layout mainContent={<ReceiveTopUpReport />} />}
          />
          <Route
            path="/retailer/WalletLoadReport"
            element={<Layout mainContent={<WalletLoadReports />} />}
          />
          <Route
            path="/retailer/WalletLoadReportV2"
            element={<Layout mainContent={<WalletLoadReportsV2 />} />}
          />
          <Route
            path="/retailer/WalletLoadReportPGT2"
            element={<Layout mainContent={<WalletLoadReportPGT2 />} />}
          />
          <Route
            path="/retailer/WalletLoadReportPGT3"
            element={<Layout mainContent={<WalletLoadReportPGT3 />} />}
          />
          <Route
            path="/retailer/WalletLoadReportPGT4"
            element={<Layout mainContent={<WalletLoadReportPGT4 />} />}
          />
          <Route
            path="/retailer/WalletLoadReportPGT5"
            element={<Layout mainContent={<WalletLoadReportPGT5 />} />}
          />
          <Route
            path="/retailer/AEPSTransactionReports"
            element={<Layout mainContent={<AepsTransactReports />} />}
          />
          <Route
            path="/retailer/AEPSPayoutReports"
            element={<Layout mainContent={<AepsPayoutReports />} />}
          />
          <Route
            path="/retailer/AepsPayoutNewReports"
            element={<Layout mainContent={<AepsPayoutNewReport />} />}
          />
          <Route
            path="/retailer/RechargeReports"
            element={<Layout mainContent={<RechargeReports />} />}
          />
          <Route
            path="/retailer/AEPSLedgerReports"
            element={<Layout mainContent={<AepsLedgerReports />} />}
          />
          <Route
            path="/retailer/ScanAndPayReports"
            element={<Layout mainContent={<ScanAndPayReports />} />}
          />
          <Route
            path="/retailer/TutionFeesReports"
            element={<Layout mainContent={<PayRentReports />} />}
          />
          <Route
            path="/retailer/AccountOpeningReports"
            element={<Layout mainContent={<AccountOpenReports />} />}
          />
          <Route
            path="/retailer/DMTWithKycReports"
            element={<Layout mainContent={<DMTV2Reports />} />}
          />
          <Route
            path="/retailer/ExpressDMTReports"
            element={<Layout mainContent={<ExpressDMTReports />} />}
          />
          <Route
            path="/retailer/LoadAccountReports"
            element={<Layout mainContent={<AccLoadReports />} />}
          />
          <Route
            path="/retailer/QRTranReport"
            element={<Layout mainContent={<QrTransReports />} />}
          />
          <Route
            path="/retailer/CreditCardBillPaymentReport"
            element={<Layout mainContent={<CreditCardBillPaymetnReports />} />}
          />
          <Route
            path="/retailer/ElectricityBillPaymentReport"
            element={<Layout mainContent={<ElectricityBillPaymentReports />} />}
          />
          <Route
            path="/retailer/PayoutReport"
            element={<Layout mainContent={<PayoutReports />} />}
          />
          <Route
            path="/retailer/CMSReports"
            element={<Layout mainContent={<CmsReports />} />}
          />
          <Route
            path="/retailer/MATMTranReport"
            element={<Layout mainContent={<MatmTranssactionReports />} />}
          />
          <Route
            path="/retailer/RefundWallet"
            element={<Layout mainContent={<RefundWallet />} />}
          />
          <Route
            path="/retailer/AEPS"
            element={<Layout mainContent={<AEPSMain />} />}
          />
          <Route
            path="/retailer/AepsV2"
            element={<Layout mainContent={<AEPSMainV2 />} />}
          />
          <Route
            path="/retailer/PagePrintCallbackUrl"
            element={<Layout mainContent={<PageprintCallback />} />}
          />
          {/* <Route
            path="/retailer/AEPS-Payout-To-Bank"
            element={<Layout mainContent={<AepsToBank />} />}
          /> */}
          <Route
            path="/retailer/AEPS-Payout-To-Bank-V2"
            element={<Layout mainContent={<AepsToBankV2 />} />}
          />
          <Route
            path="/retailer/AEPS-Payout-To-Wallet"
            element={<Layout mainContent={<AepsToWallet />} />}
          />
          <Route
            path="/retailer/MobileRecharge"
            element={<Layout mainContent={<MobileRecharge />} />}
          />
          <Route
            path="/retailer/MobilePostpaidResp"
            element={<Layout mainContent={<MobilePostpaidResp />} />}
          />
          <Route
            path="/retailer/DTHRecharge"
            element={<Layout mainContent={<DTHRecharge />} />}
          />
          <Route
            path="/retailer/TutionFees"
            element={<Layout mainContent={<PayrentMain />} />}
          />
          <Route
            path="/retailer/TutionFeesResp"
            element={<Layout mainContent={<PayrentResp />} />}
          />
          <Route
            path="/retailer/PayrentRazorpayResp"
            element={<Layout mainContent={<PayrentRazorpayResp />} />}
          />
          <Route
            path="/retailer/MyDetails"
            element={<Layout mainContent={<MyDetails />} />}
          />
          <Route
            path="/retailer/Complaints"
            element={<Layout mainContent={<Complaints />} />}
          />
          <Route
            path="/retailer/WalletToWallet"
            element={<Layout mainContent={<WalletToWallet />} />}
          />
          <Route
            path="/retailer/AccountOpening"
            element={<Layout mainContent={<YPayAcc />} />}
          />
          <Route
            path="/retailer/KYC"
            element={<Layout mainContent={<KYC />} />}
          />
          <Route
            path="/retailer/AccountRegistration"
            element={<Layout mainContent={<Registration />} />}
          />
          <Route
            path="/retailer/CardSelection"
            element={<Layout mainContent={<CardSelection />} />}
          />
          <Route
            path="/retailer/AssignCard"
            element={<Layout mainContent={<AssignCard />} />}
          />
          <Route
            path="/retailer/AccountServices"
            element={<Layout mainContent={<YpayServicesPage />} />}
          />
          <Route
            path="/retailer/AccountServices/TransactionHistory"
            element={<Layout mainContent={<TransactionHistory />} />}
          />
          <Route
            path="/retailer/AccountServices/PrepaidCards/:name"
            element={<Layout mainContent={<PrepaidCards />} />}
          />
          <Route
            path="/retailer/AccountServices/LoadAccount/:name"
            element={<Layout mainContent={<LoadAcc />} />}
          />
          <Route
            path="/retailer/AccountServices/Passbook"
            element={<Layout mainContent={<Passbook />} />}
          />
          <Route
            path="/Support"
            element={<Layout mainContent={<Support />} />}
          />
          <Route
            path="/retailer/WalletLoadResp/"
            element={<Layout mainContent={<WalletLoadResp />} />}
          />
          <Route
            path="/retailer/WalletLoadRespV2/"
            element={<Layout mainContent={<WalletLoadRespV2 />} />}
          />
          <Route
            path="/retailer/RazorWalletLoadResp/"
            element={<Layout mainContent={<RazorWalletLoadResp />} />}
          />
          <Route
            path="/retailer/RazorWalletLoadRespV2/"
            element={<Layout mainContent={<RazorWalletLoadRespV2 />} />}
          />
          <Route
            path="/retailer/RazorWalletLoadPGT2Resp/"
            element={<Layout mainContent={<RazorWalletLoadPGT2Resp />} />}
          />
          <Route
            path="/retailer/PayUWalletLoadPGT3Resp/"
            element={<Layout mainContent={<PayUWalletLoadPGT3Resp />} />}
          />
          <Route
            path="/retailer/PayUWalletLoadPGT4Resp/"
            element={<Layout mainContent={<PayUWalletLoadPGT4Resp />} />}
          />
          <Route
            path="/retailer/CashFreeWalletLoadPGT5Resp/"
            element={<Layout mainContent={<CashFreeWalletLoadPGT5Resp />} />}
          />{" "}
          <Route
            path="/retailer/PayUWalletLoadPGT3TplusOneResp/"
            element={
              <Layout mainContent={<PayUWalletLoadPGT3TplusOneResp />} />
            }
          />
          <Route
            path="/retailer/PayUWalletLoadPGT4TplusOneResp/"
            element={
              <Layout mainContent={<PayUWalletLoadPGT4TplusOneResp />} />
            }
          />
          <Route
            path="/retailer/CashFreeWalletLoadPGT5TplusOneResp/"
            element={
              <Layout mainContent={<CashFreeWalletLoadPGT5TplusOneResp />} />
            }
          />
          <Route
            path="/retailer/RazorpayPgOneTPlusOneResp/"
            element={<Layout mainContent={<RazorpayPgOneTPlusOneResp />} />}
          />
          <Route
            path="/retailer/RazorpayPGTTPlusOneResp/"
            element={<Layout mainContent={<RazorpayPGTTPlusOneResp />} />}
          />
          <Route
            path="/retailer/RazorpayPGTTwoTPlusOneResp/"
            element={<Layout mainContent={<RazorpayPGTTwoTPlusOneResp />} />}
          />
          <Route
            path="/retailer/creditCardBillPayment/"
            element={<Layout mainContent={<CreditCardPayment />} />}
          />
          {/* <Route
            path="/retailer/electricityBillPayment/"
            element={<Layout mainContent={<ElectricityBillPayment />} />}
          /> */}
          {/* Retailer BBPS */}
          <Route
            path="/retailer/bbps/electricity"
            element={<Layout mainContent={<BBPSElectricityBillPayment />} />}
          />
          <Route
            path="/retailer/bbps/mobilepostpaid"
            element={<Layout mainContent={<BBPSMobilePostpaidBillPayment />} />}
          />
          <Route
            path="/retailer/bbps/creditcard"
            element={<Layout mainContent={<BBPSCreditCardBillPayment />} />}
          />
          <Route
            path="/retailer/bbps/service"
            element={<Layout mainContent={<BBPSService />} />}
          />
          <Route
            path="/retailer/bbps/Bbpspgresp"
            element={<Layout mainContent={<Bbpspgresp />} />}
          />
          <Route
            path="/retailer/bbps/electricityresp"
            element={<Layout mainContent={<ElectricityResp />} />}
          />
          {/* //distributor  */}
          <Route
            path="/distributor/Dashboard"
            element={
              <LayoutDistributor mainContent={<DistributorDashboard />} />
            }
          />
          <Route
            path="/SuperDistributorDashboard/SuperDistributorDashboard"
            element={
              <SuperDistributorLayout
                mainContent={<SuperDistributorDashboard />}
              />
            }
          />
          <Route
            path="SuperDistributor/CreateDistributer/CreateDistributor"
            element={
              <SuperDistributorLayout mainContent={<CreateDistributor />} />
            }
          />
          <Route
            path="SuperDistributor/ReceiveTopUpReportSd"
            element={
              <SuperDistributorLayout mainContent={<ReceiveTopUpReportSd />} />
            }
          />
          <Route
            path="SuperDistributor/LedgerReportSd"
            element={
              <SuperDistributorLayout mainContent={<LedgerReportSd />} />
            }
          />
          <Route
            path="SuperDistributor/WalletLoadReportSd"
            element={
              <SuperDistributorLayout mainContent={<WalletLoadReportSd />} />
            }
          />
          <Route
            path="SuperDistributor/GetTopupRequestReportSd"
            element={
              <SuperDistributorLayout
                mainContent={<GetTopupRequestReportSd />}
              />
            }
          />
          <Route
            path="SuperDistributor/SentTopupReportSd"
            element={
              <SuperDistributorLayout mainContent={<SentTopupReportSd />} />
            }
          />
          <Route
            path="SuperDistributor/DistributorListSd"
            element={
              <SuperDistributorLayout mainContent={<DistributorListSd />} />
            }
          />
          <Route
            path="SuperDistributor/DistributorProfileSd/:id"
            element={
              <SuperDistributorLayout mainContent={<DistributorProfileSd />} />
            }
          />
          <Route
            path="/distributor/RetailerProfile/:id"
            element={<LayoutDistributor mainContent={<RetailerProfile />} />}
          />
          <Route
            path="/distributor/ReceiveTopUpReport"
            element={<LayoutDistributor mainContent={<ReceiveTopUpReport />} />}
          />
          <Route
            path="/distributor/LedgerReport"
            element={<LayoutDistributor mainContent={<LedgerReports />} />}
          />
          <Route
            path="/distributor/WalletLoadReport"
            element={<LayoutDistributor mainContent={<WalletLoadReports />} />}
          />
          <Route
            path="/distributor/MyRetailers"
            element={<LayoutDistributor mainContent={<RetailersList />} />}
          />
          <Route
            path="/distributor/MyDetails"
            element={
              <LayoutDistributor mainContent={<MyDetailsDistributor />} />
            }
          />
          <Route
            path="/distributor/devices/MATM"
            element={<LayoutDistributor mainContent={<DMATM />} />}
          />
          <Route
            path="/distributor/CreateRetailer"
            element={<LayoutDistributor mainContent={<CreateRetailerMain />} />}
          />
          <Route
            path="/distributor/WalletLoadResp/"
            element={
              <LayoutDistributor mainContent={<WalletLoadRespDistributor />} />
            }
          />
          <Route
            path="/distributor/GetTopupRequestReport/"
            element={
              <LayoutDistributor mainContent={<GetTopUpRequestReports />} />
            }
          />
          <Route
            path="/distributor/SentTopupReport/"
            element={<LayoutDistributor mainContent={<SendTopupReports />} />}
          />
          <Route
            path="/distributor/CommissionReport/"
            element={
              <LayoutDistributor mainContent={<DistributorCommission />} />
            }
          />
          <Route
            path="/distributor/QRTranReport"
            element={<LayoutDistributor mainContent={<QrTransReports />} />}
          />
          <Route
            path="/distributor/RetWalletLoadReport"
            element={
              <LayoutDistributor mainContent={<DistRetWalletLoadReports />} />
            }
          />
          <Route
            path="/distributor/RetWalletLoadReportV2"
            element={
              <LayoutDistributor mainContent={<DistRetWalletLoadReportsV2 />} />
            }
          />
          <Route
            path="/distributor/RetWalletLoadPGT2"
            element={
              <LayoutDistributor mainContent={<DistRetWalletLoadPGT2 />} />
            }
          />
          <Route
            path="/distributor/RetWalletLoadPGT3"
            element={
              <LayoutDistributor mainContent={<DistRetWalletLoadPGT3 />} />
            }
          />
          <Route
            path="/distributor/RetWalletLoadPGT4"
            element={
              <LayoutDistributor mainContent={<DistRetWalletLoadPGT4 />} />
            }
          />
                    <Route
            path="/distributor/RetWalletLoadPGT5"
            element={
              <LayoutDistributor mainContent={<DistRetWalletLoadPGT5 />} />
            }
          />
          <Route
            path="/distributor/RetQrReport"
            element={<LayoutDistributor mainContent={<DistRetQrReports />} />}
          />
          <Route
            path="/test"
            element={<LayoutDistributor mainContent={<Test />} />}
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
